import { Instagram, Film, Circle, Music2, Youtube, Facebook, Linkedin, Globe } from "lucide-react";

export const CHANNELS = [
  { key: "instagram_feed", label: "Instagram feed", icon: Instagram },
  { key: "instagram_reel", label: "Instagram reel", icon: Film },
  { key: "instagram_historia", label: "Instagram historia", icon: Circle },
  { key: "tiktok", label: "TikTok", icon: Music2 },
  { key: "youtube", label: "YouTube", icon: Youtube },
  { key: "facebook", label: "Facebook", icon: Facebook },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin },
  { key: "web", label: "Web", icon: Globe },
];

export const channelMeta = (key) => CHANNELS.find((c) => c.key === key) || CHANNELS[0];

export const POST_TYPES = [
  { key: "imagen_unica", label: "Imagen única" },
  { key: "carrusel", label: "Carrusel" },
  { key: "video", label: "Video" },
  { key: "historia", label: "Historia" },
  { key: "texto", label: "Texto" },
];

export const STATUSES = [
  { key: "borrador", label: "Borrador", dot: "#6E6E73" },
  { key: "revision_interna", label: "En revisión interna", dot: "#6E6E73" },
  { key: "enviado_cliente", label: "Enviado al cliente", dot: "#16161A" },
  { key: "cambios_solicitados", label: "Cambios solicitados", dot: "#A63D2E" },
  { key: "aprobado", label: "Aprobado", dot: "#3F6B4F" },
  { key: "publicado", label: "Publicado", dot: "#3F6B4F" },
];

export const statusMeta = (key) => STATUSES.find((s) => s.key === key) || STATUSES[0];

export const MONTHS = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
export const WEEKDAYS = ["lun", "mar", "mié", "jue", "vie", "sáb", "dom"];
